module.exports = __webpack_public_path__ + "05_short_gray.64c147cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_short_gray.png
// module id = foc4
// module chunks = 0